import { render, staticRenderFns } from "./MemberAuthDetail.vue?vue&type=template&id=2cce3fda&scoped=true"
import script from "./MemberAuthDetail.vue?vue&type=script&lang=js"
export * from "./MemberAuthDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberAuthDetail.vue?vue&type=style&index=0&id=2cce3fda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce3fda",
  null
  
)

export default component.exports